import { Hex, hexToString, toHex } from 'viem';
import { SchemaSubaccountDto } from '../generated/apiTypes';

/**
 * Decode a subaccount name from hex to string. Since encoded names are padded
 * to 32 bytes, trailing 0 bytes are decoded as \u0000, so we trim them.
 *
 * @example
 * decodeSubaccountName('0x7072696d61727900000000000000000000000000000000000000000000000000')
 * // Returns: 'primary'
 */
export const decodeSubaccountName = (encodedName: Hex): string =>
  // eslint-disable-next-line no-control-regex
  hexToString(encodedName).replaceAll(/\u0000/g, '');

/**
 * Encode a subaccount name as a 32-byte hex string. If the name is shorter than
 * 32 bytes, it will be padded with zeros.
 *
 * @throws If the input is longer than 32 bytes.
 *
 * @example
 * encodeSubaccountName('primary')
 * // Returns: '0x7072696d61727900000000000000000000000000000000000000000000000000'
 */
export const encodeSubaccountName = (name: string): Hex => toHex(name, { size: 32 });

export const hasRegisteredSubaccount = (subaccounts?: SchemaSubaccountDto[]) =>
  Boolean(subaccounts?.some((subaccount) => subaccount.registeredBlockNumber));
